/**
 * Vistas y roles del panel (decisión §4.5 y §4.6).
 * Es solo interfaz: el servidor ya exige superadmin donde corresponde
 * (server.ts, resolveAdmin / requireAdmin).
 */
export type AdminView =
  | "turnos"
  | "carteles"
  | "cfg:farmacias"
  | "cfg:plantillas"
  | "cfg:portada"
  | "cfg:bot"
  | "cfg:correos"
  | "cfg:accesos";

export type AdminRole = "super" | "turnos";

/** Igual que SUPER_ADMIN_EMAIL de server.ts (su valor por defecto). */
export const SUPER_ADMIN_EMAIL = "dataly.com.ar@gmail.com";

/** Lo único que ve el admin de turnos (§1.7). */
const TURNOS_VIEWS: AdminView[] = ["turnos", "cfg:farmacias"];

export function canSee(role: AdminRole, view: AdminView): boolean {
  return role === "super" || TURNOS_VIEWS.includes(view);
}

/**
 * Rol de un email: el superadmin es fijo; el admin de turnos es el
 * `adminEmail` de la configuración de la portada. null = sin permiso.
 * Misma regla que resolveAdmin() en server.ts.
 */
export function getAdminRole(email?: string | null, adminEmail?: string | null): AdminRole | null {
  const e = (email || "").trim().toLowerCase();
  if (!e) return null;
  if (e === SUPER_ADMIN_EMAIL) return "super";
  const a = (adminEmail || "").trim().toLowerCase();
  if (a && e === a) return "turnos";
  return null;
}
